<template>
  <Modal v-if="Object.keys(blockers).length > 0" :full-size="false" :close-btn="false">
    <div class="p-3 flex flex-col items-center justify-center h-full text-center space-y-4">
      <p>{{ blockingMsg }}</p>
      <LoadCard />
    </div>
  </Modal>
</template>

<script setup>
import { computed, onBeforeUnmount, ref } from 'vue';
import { hook, unhook } from './uiBlockAPI';
import Modal from '../../Modal.vue';
import LoadCard from '../../components/LoadCard.vue';

const blockers = ref({})

hook(
  (msg, token) => {
    blockers.value = {
      ...blockers.value,
      [token]: msg
    } 
  },
  token => {
    const next = {...blockers.value}
    delete next[token]
    blockers.value = next
  }
)

onBeforeUnmount(() => {
  unhook()
})

const blockingMsg = computed(() => {
  const keys = Object.keys(blockers.value)
  if (!keys.length) {
    return null
  }
  return blockers.value[keys[keys.length - 1]]
})

</script>
